<template>
    <section class="progress-wrap">
        <div class="y-axis">
            <div class="item" v-for="(item, i) in data" :key="i">
                <label>{{ item.key }}</label>
                <div class="bar" :style="`width: ${item.value ? item.value / max_data * 100 : 0}%;`"></div>
                {{ item.value }}
            </div>
        </div>
        <div class="x-axis">
            <span v-for="(x, i) in x_data" :key="i">{{ x }}</span>
        </div>
    </section>
</template>
<script>

export default {
    computed: {
        data () {
            return Object.keys(this.category_stat).map(key => {
                return {
                    key,
                    value: this.category_stat[key]
                }
            })
        },
        max_data () {
            const stats = this.data.map(({ value }) => value)
            const max = Math.max.apply(Math, stats)
            return Math.ceil(max * 1.2)
        },
        x_data () {
            const max = this.max_data
            const len = max < 5 && max > 0 ? max : 5
            const data = []
            const start = max / len
            for (let i = 0; i < len + 1; i++) {
                data.push(Math.ceil(start * i))
            }
            return data
        }
    },
    props: {
        category_stat: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>
<style lang="scss" scoped>
$chart-width: 1015px;
.progress-wrap {
    padding: 26px 58px 25px 106px;
    background: #fff;
}
.y-axis {
    width: $chart-width;
    border-left: 1px solid #E1E2E6;
    padding-bottom: 20px;
    label {
        position: absolute;
        left: -70px;
        font-size: 14px;
        color: #606266;
        text-align: left;
    }
}
.item {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    height: 20px;
    margin-bottom: 20px;
    background-color: #F0F1F5;
    font-size: 13px;
    .bar {
        display: inline-block;
        height: 100%;
        transition: width 1.5s ease-in-out;
        margin-right: 1em;
    }
    &:first-child .bar {
        background-color: #8349F5;
    }
    &:nth-child(2) .bar {
        background-color: #00CCCC;
    }
    &:last-child .bar {
        background-color: #3DCC85;
    }
    &:last-child {
        margin: 0;
    }
}
.x-axis {
    display: flex;
    justify-content: space-between;
    width: $chart-width;
    border-top: 1px solid #E1E2E6;
    > span {
        flex: 1;
        margin-top: 9px;
        text-align: right;
        color: #606266;
        font-size: 12px;
        &:first-child {
            flex: 0;
        }
    }
}
</style>
